import { Link } from "react-router-dom";
import styles from "./Board.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Board({ columns, data }) {
  return (
    <div className={cx("tableResponsive")}>
      <table className={cx("board")}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.style} className={cx("tabHeader")}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className={cx("tabBody")}>
          {data.map((row) => (
            <tr key={row.id}>
              {columns.map((col) => (
                <td key={col.key} style={col.style} className={cx("tabData")}>
                  {col.key === "title" ? (
                    <Link to={`${row.id}`} className={cx("titleLink")}>
                      {row[col.key]}
                    </Link>
                  ) : (
                    row[col.key]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
